import { render, staticRenderFns } from "./DeletingData.vue?vue&type=template&id=4f0969fa"
import script from "./DeletingData.vue?vue&type=script&lang=js"
export * from "./DeletingData.vue?vue&type=script&lang=js"
import style0 from "./DeletingData.vue?vue&type=style&index=0&id=4f0969fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports